export default "__VITE_ASSET__92e$bHHq__"